import { ElMessage } from 'element-plus';

const { CMapFactory, CMapStore, PickerHelper, MessagePopup } = map3dC;

MessagePopup.info = ElMessage.info;
MessagePopup.success = ElMessage.success;
MessagePopup.warning = ElMessage.warning;
MessagePopup.error = ElMessage.error;

const tdtToken = 'c2fa9f14e6e0ce6254c65ad064e3dc9c';
let annotationLayer = null;

function createAnnotationProvider() {
  return new Cesium.UrlTemplateImageryProvider({
    // url: `http://t{s}.tianditu.gov.cn/DataServer?T=cva_w&X={x}&Y={y}&L={z}&tk=${tdtToken}`,
    url: `https://t{s}.tianditu.gov.cn/DataServer?T=cva_w&X={x}&Y={y}&L={z}&tk=${tdtToken}`,
    subdomains: ['0', '1', '2', '3', '4', '5', '6', '7'],
    maximumLevel: 18,
  });
}

function removeAnnotationLayer() {
  if (!annotationLayer) {
    return;
  }
  const layer = annotationLayer;
  if (viewer?.imageryLayers?.contains(layer)) {
    viewer.imageryLayers.remove(layer, true);
  }
  annotationLayer = null;
}

function addAnnotationLayer() {
  const layer = annotationLayer;
  if (layer && viewer.imageryLayers.contains(layer)) {
    return;
  }
  annotationLayer = viewer.imageryLayers.addImageryProvider(createAnnotationProvider());
}

/**
 * 创建viewer
 * @param {string} containerId
 * @returns {map3dC.CMap}
 */
export async function createCMap(containerId) {
  const cmap = CMapFactory.create(containerId);
  cmap.initNavigation({
    enableCompass: true,
    enableZoomControls: false,
    enableDistanceLegend: true,
    enableCompassOuterRing: true,
  });
  await cmap.baseMapManager.initialize([
    {
      type: 'urlTemplate',
      // url: `https://t{s}.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=${tdtToken}`,
      url: `https://t{s}.tianditu.gov.cn/vec_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=${tdtToken}`,
      // url: `https://t{s}.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=${tdtToken}`,
      options: {
        spatialReference: {
          wkid: 3857,
        },
        subdomains: ['0', '1', '2', '3', '4', '5', '6', '7'],
        maximumLevel: 18,
        requestMetaInfo: false,
      },
    },
    {
      type: 'urlTemplate',
      // url: `http://t{s}.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=${tdtToken}`,
      url: `https://t{s}.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=${tdtToken}`,
      options: {
        spatialReference: {
          wkid: 3857,
        },
        subdomains: ['0', '1', '2', '3', '4', '5', '6', '7'],
        maximumLevel: 18,
        requestMetaInfo: false,
      },
    },
  ]);
  cmap.baseMapManager.currentFeature.imageryLayer.contrast = -1.0;
  cmap.baseMapManager.currentFeature.imageryLayer.hue = 4;
  cmap.baseMapManager.currentFeature.imageryLayer.saturation = 0;

  cmap.bindAutoToggle23DMode();

  const viewer = cmap.viewer;
  viewer.scene.globe.depthTestAgainstTerrain = true;
  viewer.debugShowFramesPerSecond = false;
  viewer.scene.screenSpaceCameraController.minimumZoomDistance = 20;
  viewer.scene.screenSpaceCameraController.maximumZoomDistance = 6500000;
  flyToHome(containerId);

  const pickerHelper = new PickerHelper(viewer);
  pickerHelper.on('MIDDLE_CLICK', () => {
    cmap.debugFramesPerSecond = !cmap.debugFramesPerSecond;
  });
  cmap.toggleDebugFramesPerSecondPickerHelper = pickerHelper;

  window.viewer = viewer;
  return cmap;
}

/**
 * 获取viewer
 * @param {string} containerId
 * @returns {map3dC.CMap}
 */
export function getCMap(containerId) {
  const cmap = CMapStore.getInstance().getMap(containerId);
  return cmap;
}

/**
 * 销毁viewer
 * @param {string} containerId
 */
export function destroyCMap(containerId) {
  const cmapStore = CMapStore.getInstance();
  if (cmapStore.hasMap(containerId)) {
    const cmap = cmapStore.getMap(containerId);
    removeAnnotationLayer(cmap);
    if (cmap.toggleDebugFramesPerSecondPickerHelper) {
      cmap.toggleDebugFramesPerSecondPickerHelper.destroy();
      delete cmap.toggleDebugFramesPerSecondPickerHelper;
    }
    CMapFactory.destroy(cmap);
  }
}

/**
 * 切换自动切换视锥体
 * @param {string} containerId
 * @param {boolean} toggle
 */
export function toggleAutoToggleFrustum(containerId, toggle) {
  const cmapStore = CMapStore.getInstance();
  if (cmapStore.hasMap(containerId)) {
    const cmap = cmapStore.getMap(containerId);
    const viewer = cmap.viewer;
    if (toggle) {
      viewer.cmap.isToggleFrustum = true;
    } else {
      viewer.cmap.isToggleFrustum = false;
    }
  }
}

/**
 * 切换2/3D
 * @param {string} containerId
 * @param {boolean} toggle
 */
export function toggle23DMode(containerId, toggle) {
  const cmapStore = CMapStore.getInstance();
  if (cmapStore.hasMap(containerId)) {
    const cmap = cmapStore.getMap(containerId);
    const viewer = cmap.viewer;
    viewer.cmap.toggle23DMode(toggle);
  }
}

/**
 * 获取2/3D模式
 * @param {string} containerId
 * @returns {boolean}
 */
export function get23DMode(containerId) {
  const cmapStore = CMapStore.getInstance();
  if (cmapStore.hasMap(containerId)) {
    const cmap = cmapStore.getMap(containerId);
    const viewer = cmap.viewer;
    return viewer.cmap.scene23DMode;
  }
  return true;
}

/**
 * 切换侦测底图与注记图层
 * 开启：影像底图(img_w) + 全国矢量注记(cva_w)
 * 关闭：仅保留原天地图底图
 * @param {string} containerId
 * @param {number} layerIndex 0: 原底图, 1: 侦测影像底图
 */
export function toggleAnnotation(containerId, layerIndex) {
  const cmapStore = CMapStore.getInstance();
  if (!cmapStore.hasMap(containerId)) {
    return;
  }
  const cmap = cmapStore.getMap(containerId);
  cmap.baseMapManager.switch(layerIndex);
  if (layerIndex === 1) {
    addAnnotationLayer(cmap);
  } else {
    removeAnnotationLayer(cmap);
  }
}

/**
 * 飞行到Home位置
 * @param {string} containerId
 */
export function flyToHome(containerId) {
  const cmapStore = CMapStore.getInstance();
  if (cmapStore.hasMap(containerId)) {
    const cmap = cmapStore.getMap(containerId);
    const viewer = cmap.viewer;
    viewer.camera.setView({
      // 中国范围
      destination: Cesium.Cartesian3.fromDegrees(109.58656769038934, 33.185632550013445, 6500000),
      orientation: {
        heading: 0,
        pitch: Cesium.Math.toRadians(-90.0),
        roll: 0.0,
      },
    });
  }
}
